import React from "react";
import {Outlet, useLocation} from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";
import SideNavbar from "../../components/sideNavbar/SideNavbar";

// import {useEffect} from "react";
// import {useRefreshToken} from "../../services/api/auth/refresh/useRefreshToken";
import styles from "./PrivateRouteLayout.module.scss";

const PrivateRouteLayout = () => {
  // TODO: Determine is this is a necessary check
  //const refresh = useRefreshToken();
  // useEffect(() => {
  //   const onRefresh = async () => {
  //     await refresh.mutateAsync();
  //   };
  //   onRefresh();
  // }, []);

  const location = useLocation();
  const currentRoute = location.pathname;

  const noNavbarRoutes = ["/welcome"];

  const privateLayoutRequiresOpenScreen = noNavbarRoutes.includes(currentRoute);

  const OpenScreen = () => (
    <div className={styles.app}>
      <div className={styles.contentContainer}>
        <Outlet />
      </div>
    </div>
  );

  const ContainedScreen = () => (
    <div className={styles.app}>
      <SideNavbar />
      <div className={styles.contentContainer}>
        <Navbar />
        <Outlet />
      </div>
    </div>
  );

  return privateLayoutRequiresOpenScreen ? <OpenScreen /> : <ContainedScreen />;
};

export default PrivateRouteLayout;
